import React from "react";
import "./contact.css";
import Header from "components/Header";
import Footer from "components/Footer";
import ContactForm from "components/Form";

const Contact = () => {
  return (
    <div className="contact-component">
      <Header />
      <div className="contact">
        <div className="contact-terminal">
          <div className="terminal-header">
            <div className="terminal-buttons">
              <span className="btn-close"></span>
              <span className="btn-minimize"></span>
              <span className="btn-maximize"></span>
            </div>
            <div className="terminal-title">vincent@portfolio:~/contact</div>
          </div>
          <div className="terminal-body">
            <div className="terminal-output">
              <pre className="ascii-art">{`
     ██████╗ ██████╗ ███╗   ██╗████████╗ █████╗  ██████╗████████╗
    ██╔════╝██╔═══██╗████╗  ██║╚══██╔══╝██╔══██╗██╔════╝╚══██╔══╝
 ██║     ██║   ██║██╔██╗ ██║   ██║   ███████║██║        ██║
 ██║     ██║   ██║██║╚██╗██║   ██║   ██╔══██║██║        ██║
 ╚██████╗╚██████╔╝██║ ╚████║   ██║   ██║  ██║╚██████╗   ██║
  ╚═════╝ ╚═════╝ ╚═╝  ╚═══╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝   ╚═╝
              `}</pre>
              <div className="command-line">
                <span className="prompt">$</span>
                <span className="command"> cat contact_info.txt</span>
              </div>
              <div className="output-text">
                <p>
                  <span className="key">Email:</span>{" "}
                  <a href="mailto:vincentshiwork@gmail.com">
                    vincentshiwork@gmail.com
                  </a>
                </p>
                <p>
                  <span className="key">Status:</span>{" "}
                  <span className="status-online">
                    ● Available for opportunities
                  </span>
                </p>
              </div>
              <div className="command-line">
                <span className="prompt">$</span>
                <span className="command"> ./send_message.sh</span>
              </div>
            </div>
            <ContactForm className="contact-form" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
